import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { pageRoute } from '../../../constant/pageRoute';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'bo-intake-sidebar',
  templateUrl: './intake-sidebar.component.html',
  styleUrls: ['./intake-sidebar.component.scss']
})
export class IntakeSidebarComponent implements OnInit {
  private _data = new BehaviorSubject<boolean>(false);

  @Input()
  set toggle(value: boolean) {
    this._data.next(value);
  }
  get toggle(): boolean {
    return this._data.getValue();
  }

  @Output() menuToggle = new EventEmitter<boolean>();
  
  sidebar: string = "sidebar";
  iconNav: string = "icon-nav";
  pageRoute = pageRoute;

  constructor() { }

  ngOnInit(): void {
    this._data.subscribe(x => {
      this.updateSidebarClasses(x);
    });
  }

  updateSidebarClasses(isToggle: boolean): void {
    if (isToggle) {
      this.sidebar = "toggle-sidebar";
      this.iconNav = "toggle-icon-nav";
    } else {
      this.sidebar = "sidebar";
      this.iconNav = "icon-nav";
    }
  }

  onToggle(): void {
    this.toggle = !this.toggle;
    this.menuToggle.emit(this.toggle);
  }
}
